import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations as modules to avoid bundling issues
const resources = {
  de: {
    translation: {
      "common": {
        "loading": "Laden...",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "create": "Erstellen",
        "close": "Schließen",
        "back": "Zurück",
        "next": "Weiter",
        "search": "Suchen",
        "filter": "Filter",
        "all": "Alle"
      },
      "navigation": {
        "home": "Startseite",
        "about": "Über uns",
        "training": "Training",
        "tournaments": "Turniere",
        "events": "Events",
        "gallery": "Galerie",
        "blog": "News",
        "contact": "Kontakt"
      },
      "languages": {
        "de": "Deutsch",
        "en": "English",
        "fr": "Français",
        "es": "Español",
        "it": "Italiano",
        "pt": "Português",
        "pl": "Polski",
        "cs": "Čeština",
        "hu": "Magyar",
        "uk": "Українська",
        "ru": "Русский"
      },
      "events": {
        "title": "Events",
        "subtitle": "Entdecke unsere kommenden Events und melde dich direkt an",
        "upcoming": "Bevorstehende Events",
        "past": "Vergangene Events",
        "noEvents": "Keine Events gefunden",
        "noEventsDescription": "Derzeit sind keine Events geplant. Schaue bald wieder vorbei!",
        "register": "Jetzt anmelden",
        "moreInfo": "Mehr Informationen",
        "addToCalendar": "Zum Kalender hinzufügen",
        "exportCalendar": "Kalender exportieren",
        "recently": "Kürzlich",
        "viewAusschreibung": "Ausschreibung ansehen"
      },
      "about": {
        "title": "Über uns",
        "subtitle": "Entdecke die Geschichte und Mission des ASC Fechten Wien",
        "history": {
          "title": "Unsere Geschichte",
          "paragraph1": "Der Academic Sports Club Fechten Wien wurde 1970 gegründet und blickt auf eine lange und erfolgreiche Tradition im Fechtsport zurück. Was als kleine Studentengruppe begann, hat sich zu einem der führenden Fechtvereine Österreichs entwickelt.",
          "paragraph2": "Über die Jahre haben wir hunderte von Fechtern ausgebildet, von Anfängern bis hin zu internationalen Wettkämpfern. Unsere Trainer bringen jahrzehntelange Erfahrung mit und haben selbst auf höchstem Niveau gefochten.",
          "paragraph3": "Heute sind wir stolz darauf, eine lebendige Gemeinschaft zu sein, die Tradition und Innovation verbindet. Unser Verein steht für Qualität, Fairplay und die Förderung des Fechtsports auf allen Ebenen.",
          "since": "Seit 1970",
          "experience": "Über 50 Jahre Erfahrung",
          "members": "200+ Mitglieder",
          "community": "Starke Gemeinschaft",
          "titles": "Zahlreiche Titel",
          "achievements": "Nationale & internationale Erfolge"
        },
        "mission": {
          "title": "Unsere Mission",
          "description": "Unser Ziel ist es, den Fechtsport in all seinen Facetten zu fördern und eine Plattform für sportliche Entwicklung und persönliches Wachstum zu bieten. Wir glauben an die transformative Kraft des Fechtsports.",
          "valueIntro": "Unsere Kernwerte sind:",
          "values": {
            "training": "Exzellente Trainingsqualität für alle Altersgruppen",
            "fairplay": "Fairplay und Respekt im Wettkampf und Training",
            "methods": "Moderne Trainingsmethoden und traditionelle Werte",
            "community": "Eine starke, unterstützende Gemeinschaft"
          }
        },
        "team": {
          "title": "Unser Team",
          "headTrainer": "Cheftrainer",
          "trainer": "Trainer",
          "youthTrainer": "Jugendtrainer",
          "descriptions": {
            "alois": "Langjähriger Cheftrainer mit internationaler Erfahrung. Spezialist für Degen und Florett mit über 40 Jahren Trainererfahrung.",
            "dorothea": "Erfahrene Trainerin für alle Waffen. Besonders engagiert in der Nachwuchsförderung und im Breitensport.",
            "dietmar": "Technischer Leiter und Spezialist für moderne Trainingsmethoden. Fokus auf biomechanische Optimierung.",
            "viktor": "Wettkampftrainer mit Schwerpunkt auf taktischer Ausbildung. Ehemaliger Nationalmannschaftsfechter.",
            "franziska": "Nachwuchstalent und aufstrebende Trainerin. Spezialisiert auf Jugendtraining und moderne Lehrmethoden.",
            "lukas": "Jugendkoordinator und Spezialist für Anfängertraining. Bringt frischen Wind in traditionelle Trainingsmethoden.",
            "nicolas": "Junger, motivierter Trainer mit Fokus auf spielerisches Lernen und moderne Trainingsansätze."
          }
        }
      },
      "tournaments": {
        "title": "Turniere",
        "subtitle": "Spannende Wettkämpfe und große Erfolge - erlebe den Fechtsport auf höchstem Niveau",
        "upcoming": "Bevorstehende Turniere",
        "past": "Vergangene Turniere",
        "weapon": "Waffe",
        "weapons": {
          "foil": "Florett",
          "epee": "Degen",
          "sabre": "Säbel"
        },
        "registration": "Anmeldung",
        "results": "Ergebnisse",
        "archive": "Turnierarchiv",
        "showMore": "Weitere anzeigen",
        "showLess": "Weniger anzeigen",
        "noUpcoming": "Derzeit keine bevorstehenden Turniere",
        "noPast": "Keine vergangenen Turniere"
      },
      "calendar": {
        "addToGoogle": "Zu Google Calendar hinzufügen",
        "addToOutlook": "Zu Outlook hinzufügen",
        "downloadIcs": "ICS-Datei herunterladen",
        "addToCalendar": "Zum Kalender hinzufügen"
      },
      "blog": {
        "title": "Blog & News",
        "description": "Entdecke die neuesten Nachrichten, Trainingstipps und Erfolgsgeschichten aus der faszinierenden Welt des Fechtens.",
        "morePosts": "Weitere Beiträge"
      },
      "gallery": {
        "title": "Galerie",
        "description": "Einblicke in unser Vereinsleben - von Training bis zu großen Turnieren"
      },
      "training": {
        "title": "Training",
        "subtitle": "Professionelles Fechttraining für alle Altersgruppen und Leistungsstufen",
        "loading": "Lade Trainingsdaten...",
        "youthTraining": "Jugendtraining",
        "clubTraining": "Vereinstraining", 
        "studentCourses": "Studentenkurse",
        "bookableVia": "Universitätskurse - Buchbar über die",
        "usiSite": "USI-Seite",
        "filterLegend": "Filter & Legende",
        "weapons": "Waffen",
        "targetGroups": "Zielgruppen",
        "beginners": "Anfänger",
        "advanced": "Fortgeschrittene",
        "tournament": "Turnierfechter",
        "days": {
          "monday": "Montag",
          "tuesday": "Dienstag", 
          "wednesday": "Mittwoch",
          "thursday": "Donnerstag",
          "friday": "Freitag"
        },
        "registration": {
          "title": "Trainingsanmeldung",
          "subtitle": "Melde dich für ein kostenloses Probetraining an",
          "name": "Name",
          "email": "E-Mail",
          "phone": "Telefon",
          "experience": "Fechterfahrung",
          "experiencePlaceholder": "Beschreibe deine bisherige Fechterfahrung",
          "message": "Nachricht",
          "messagePlaceholder": "Weitere Informationen oder Fragen",
          "submit": "Anmeldung senden",
          "submitting": "Wird gesendet...",
          "success": "Anmeldung erfolgreich gesendet!",
          "successDescription": "Wir werden uns so schnell wie möglich bei dir melden.",
          "error": "Fehler beim Senden",
          "errorDescription": "Bitte versuche es später noch einmal oder kontaktiere uns direkt."
        }
      },
      "home": {
        "hero": {
          "title": "Willkommen beim ASC Fechten Wien",
          "subtitle": "Erlebe die Faszination des Fechtens",
          "description": "Entdecke die elegante Kunst des Fechtens in unserem traditionsreichen Verein. Vom Anfänger bis zum Profi – wir bieten für jeden das passende Training.",
          "joinButton": "Jetzt beitreten",
          "learnMoreButton": "Mehr erfahren",
          "watchVideoButton": "Video ansehen"
        },
        "fencingRules": {
          "title": "Die Regeln des Fechtens",
          "subtitle": "Verstehen Sie die Grundlagen dieses eleganten Sports",
          "videoTitle": "Einführung in die Fechtregeln",
          "basicRulesTitle": "Grundregeln des Fechtens",
          "targetZones": {
            "title": "Trefferzonen",
            "description": "Je nach Waffe variieren die gültigen Trefferzonen - vom Rumpf beim Florett bis zum ganzen Körper beim Degen."
          },
          "rightOfWay": {
            "title": "Vortrittrecht",
            "description": "Bei Florett und Säbel entscheidet das Vortrittrecht, wer bei Simultantreffern den Punkt erhält."
          },
          "scoring": {
            "title": "Punktesystem",
            "description": "Ein Gefecht geht bis 15 Treffer oder die Zeitgrenze von 9 Minuten wird erreicht."
          },
          "safety": {
            "title": "Sicherheit",
            "description": "Vollständige Schutzausrüstung und strenge Sicherheitsregeln gewährleisten maximalen Schutz."
          },
          "fairPlay": {
            "title": "Fair Play",
            "description": "Respekt vor dem Gegner und die Achtung der Regeln stehen an oberster Stelle beim Fechten."
          },
          "tip": "Tipp: Beginnen Sie mit dem Florett - es ist ideal für Einsteiger!"
        },
        "weapons": {
          "title": "Unsere Waffengattungen",
          "subtitle": "Drei Disziplinen, unendliche Möglichkeiten",
          "foil": {
            "name": "Florett",
            "description": "Das Florett ist die klassische Ausbildungswaffe des Fechtsports. Hierbei darf nur der Rumpf getroffen werden.",
            "weight": "Gewicht: ca. 500g",
            "blade": "Klinge: flexibel, rechteckiger Querschnitt",
            "target": "Trefferfläche: Rumpf",
            "rightOfWay": "Vortrittrecht: Ja",
            "motto": "Ideal für Einsteiger - Eleganz und Präzision stehen im Vordergrund"
          },
          "epee": {
            "name": "Degen",
            "description": "Der Degen ist die schwerste Waffe. Der gesamte Körper ist Trefferfläche, was taktische Vielfalt ermöglicht.",
            "weight": "Gewicht: ca. 770g",
            "blade": "Klinge: steif, dreieckiger Querschnitt",
            "target": "Trefferfläche: Ganzer Körper",
            "rightOfWay": "Vortrittrecht: Nein",
            "motto": "Für Strategen - Geduld und Timing entscheiden über Sieg und Niederlage"
          },
          "sabre": {
            "name": "Säbel",
            "description": "Der Säbel ist die dynamischste Waffe. Hieb- und Stoßtreffer sind möglich, was zu spektakulären Gefechten führt.",
            "weight": "Gewicht: ca. 500g",
            "blade": "Klinge: flexibel, rechteckiger Querschnitt",
            "target": "Trefferfläche: Oberkörper",
            "rightOfWay": "Vortrittrecht: Ja",
            "motto": "Für Tempofechter - Schnelligkeit und Aggressivität sind entscheidend"
          },
          "tryAllWeapons": "Interessiert? Probiere alle drei Waffen in unserem Schnuppertraining aus!",
          "toTrialTraining": "Zum Schnuppertraining"
        },
        "about": {
          "title": "Warum ASC Fechten Wien?",
          "description": "Über 50 Jahre Erfahrung, moderne Trainingsmethoden und eine starke Gemeinschaft machen uns zu Ihrer ersten Wahl für den Fechtsport.",
          "features": {
            "training": {
              "title": "Professionelles Training",
              "description": "Von Anfänger bis Wettkampfniveau - wir bieten das passende Training für jeden."
            },
            "community": {
              "title": "Starke Gemeinschaft",
              "description": "Teil einer lebendigen Fechtergemeinschaft werden und neue Freundschaften schließen."
            },
            "tournaments": {
              "title": "Turniere & Wettkämpfe",
              "description": "Regelmäßige Teilnahme an nationalen und internationalen Turnieren für alle Leistungsklassen."
            },
            "schedule": {
              "title": "Flexible Trainingszeiten", 
              "description": "Trainiere wann es dir passt - wir bieten Kurse für jeden Zeitplan und jedes Niveau."
            }
          }
        },
        "cta": {
          "title": "Bereit für dein erstes Training?",
          "description": "Egal ob Anfänger oder Fortgeschrittener - bei uns findest du das passende Training. Komm vorbei und entdecke die Faszination des Fechtsports!",
          "contactButton": "Kontakt aufnehmen",
          "closeVideo": "Video schließen"
        }
      },
      "header": {
        "search": "Suche",
        "searchPlaceholder": "Suche...",
        "openSearch": "Suche öffnen",
        "facebookLabel": "ASC Fechten Wien auf Facebook besuchen",
        "instagramLabel": "ASC Fechten Wien auf Instagram besuchen",
        "youtubeLabel": "ASC Fechten Wien auf YouTube besuchen"
      },
      "contact": {
        "title": "Kontakt",
        "subtitle": "Hast du Fragen oder möchtest uns kennenlernen? Wir freuen uns auf deine Nachricht!",
        "form": {
          "title": "Schreib uns",
          "name": "Name",
          "email": "E-Mail",
          "subject": "Betreff",
          "message": "Nachricht",
          "messagePlaceholder": "Deine Nachricht an uns...",
          "send": "Nachricht senden",
          "sending": "Wird gesendet...",
          "required": "*",
          "successTitle": "Nachricht erfolgreich gesendet!",
          "successDescription": "Wir werden uns so schnell wie möglich bei dir melden.",
          "errorTitle": "Fehler beim Senden",
          "errorDescription": "Bitte versuche es später noch einmal oder kontaktiere uns direkt."
        },
        "social": {
          "title": "Folge uns"
        },
        "info": {
          "title": "Kontaktinformationen",
          "address": {
            "title": "Adresse",
            "content": "Universitätssportzentrum Wien\nAuf der Schmelz 6\n1150 Wien, Österreich"
          },
          "phone": {
            "title": "Telefon",
            "number": "+43 69910866515",
            "note": "Erreichbar während der Trainingszeiten"
          },
          "email": {
            "title": "E-Mail",
            "address": "info@asc-fechten.com",
            "note": "Wir antworten innerhalb von 24 Stunden"
          },
          "training": {
            "title": "Trainingszeiten",
            "monday": "Montag: 16:15 - 20:30",
            "tuesday": "Dienstag: 20:00-21:30",
            "wednesday": "Mittwoch: 16:00 - 20:00",
            "thursday": "Donnerstag: 17:30 - 20:30",
            "friday": "Freitag: 16:00 - 19:00"
          }
        },
        "board": {
          "title": "Der Vorstand des ASC-Fechten Wien",
          "chairman": "Obmann und sportlicher Leiter",
          "viceChairman": "Obmann-Stellvertreter",
          "secretary": "Schriftführer",
          "treasurer": "Kassier",
          "weaponMasterFoil": "Waffenwart Florett",
          "weaponMasterEpee": "Waffenwart Degen",
          "weaponMasterSaber": "Waffenwart Säbel",
          "youth": "Jugend",
          "trustPerson": "Vertrauensperson",
          "auditor": "Rechnungsprüfer"
        },
        "partners": {
          "title": "Unsere Partner"
        }
      },
      "footer": {
        "contact": "Kontakt",
        "address": "Universitätssportzentrum Wien\nAuf der Schmelz 6, 1150 Wien",
        "phone": "+43 69910866515",
        "email": "info@asc-fechten.com",
        "trainingTimes": "Trainingszeiten",
        "monday": "Montag: 16:15 - 20:30",
        "tuesday": "Dienstag: 20:00-21:30",
        "wednesday": "Mittwoch: 16:00 - 20:00",
        "thursday": "Donnerstag: 17:30 - 20:30",
        "friday": "Freitag: 16:00 - 19:00",
        "followUs": "Folge uns",
        "quickLinks": "Schnelllinks",
        "downloads": "Downloads",
        "news": "Aktuelles",
        "tournaments": "Turniere",
        "training": "Training",
        "gallery": "Galerie",
        "archive": "Archiv",
        "bankDetails": "Bankverbindung",
        "copyright": "© 2024 Akademischer Sportclub Fechten Wien. Alle Rechte vorbehalten.",
        "webdesign": "Webdesign von Web-Resonanz",
        "impressum": "Impressum",
        "privacy": "Datenschutzerklärung",
        "terms": "AGB"
      },
      "admin": {
        "adminPanel": "Admin-Panel",
        "navigation": "Navigation",
        "dashboard": "Dashboard",
        "users": "Benutzer",
        "training": "Training",
        "blog": "Blog & News",
        "events": "Events",
        "media": "Mediathek",
        "tournaments": "Turniere",
        "files": "Dateien",
        "banner": "Banner",
        "analytics": "Statistiken",
        "settings": "Einstellungen",
        "backToWebsite": "Zur Website",
        "logout": "Abmelden",
        "userManagement": {
          "title": "Benutzerverwaltung",
          "selectRole": "Rolle auswählen",
          "noUsers": "Keine Benutzer gefunden",
          "searchPlaceholder": "Benutzer suchen...",
          "role": "Rolle",
          "email": "E-Mail",
          "displayName": "Anzeigename",
          "createdAt": "Erstellt am",
          "actions": "Aktionen",
          "totalUsers": "Benutzer gesamt",
          "administrators": "Administratoren",
          "moderators": "Moderatoren",
          "allUsers": "Alle Benutzer",
          "roles": "Rollen",
          "notSpecified": "Nicht angegeben",
          "noRoles": "Keine Rollen",
          "clickToRemove": "Klicken zum Entfernen",
          "confirmRemoveRole": "Rolle entfernen?",
          "confirmRemoveRoleMessage": "Möchten Sie die Rolle \"{{role}}\" von {{email}} wirklich entfernen?",
          "adminWarning": "Achtung: Diese Person verliert damit alle Administratorrechte.",
          "removeRole": "Rolle entfernen",
          "editUser": "Benutzer bearbeiten",
          "assignNewRole": "Neue Rolle zuweisen",
          "assign": "Zuweisen",
          "user": "Benutzer",
          "moderator": "Moderator",
          "administrator": "Administrator",
          "cancel": "Abbrechen",
          "save": "Speichern",
          "deleteUser": "Benutzer löschen",
          "confirmDeleteUser": "Benutzer löschen?",
          "confirmDeleteMessage": "Diese Aktion kann nicht rückgängig gemacht werden. Das Konto und alle zugehörigen Daten werden dauerhaft gelöscht.",
          "errors": {
            "loadUsers": "Benutzer konnten nicht geladen werden",
            "roleExists": "Diese Rolle ist bereits zugewiesen",
            "selfAdmin": "Sie können sich nicht selbst zum Administrator machen",
            "assignRole": "Rolle konnte nicht zugewiesen werden",
            "selfRemoveAdmin": "Sie können sich die Administratorrolle nicht selbst entziehen",
            "lastAdmin": "Der letzte Administrator kann nicht entfernt werden",
            "removeRole": "Rolle konnte nicht entfernt werden",
            "updateProfile": "Profil konnte nicht gespeichert werden",
            "selfDelete": "Sie können sich nicht selbst löschen",
            "deleteUser": "Benutzer konnte nicht gelöscht werden"
          },
          "success": {
            "roleAssigned": "Rolle \"{{role}}\" wurde zugewiesen",
            "roleRemoved": "Rolle \"{{role}}\" wurde entfernt",
            "profileUpdated": "Profil wurde gespeichert",
            "userDeleted": "Benutzer wurde gelöscht"
          }
        },
        "placeholders": {
          "eventLocation": "z.B. Wien, Österreich",
          "pdfUrl": "https://vereinswebsite.at/dokument.pdf",
          "imageUrl": "https://vereinswebsite.at/bild.jpg",
          "selectWeapon": "Waffe auswählen",
          "selectGender": "Geschlecht auswählen",
          "selectSeason": "Saison auswählen",
          "selectEvent": "Event auswählen",
          "selectDay": "Tag auswählen",
          "selectLevel": "Niveau auswählen",
          "selectCategory": "Kategorie auswählen",
          "enterName": "Name eingeben...",
          "enterDescription": "Beschreibung eingeben...",
          "enterTitle": "Titel eingeben...",
          "enterAuthor": "Autor eingeben...",
          "enterTime": "z.B. 17:30 - 19:00",
          "enterAddress": "z.B. 1150, Oeverseerstr. 2C",
          "googleMapsUrl": "Google Maps URL",
          "courseInfo": "Zusätzliche Kursinformationen",
          "tags": "Tags durch Komma getrennt",
          "points": "Punkte (z.B. 206,5 P)",
          "position": "Position",
          "filename": "Dateiname eingeben...",
          "searchFiles": "Dateien durchsuchen..."
        }
      }
    }
  },
  en: {
    translation: {
      "common": {
        "loading": "Loading...",
        "save": "Save",
        "cancel": "Cancel",
        "delete": "Delete",
        "edit": "Edit",
        "create": "Create",
        "close": "Close",
        "back": "Back",
        "next": "Next",
        "search": "Search",
        "filter": "Filter",
        "all": "All"
      },
      "navigation": {
        "home": "Home",
        "about": "About Us",
        "training": "Training",
        "tournaments": "Tournaments",
        "events": "Events",
        "gallery": "Gallery",
        "blog": "News",
        "contact": "Contact"
      },
      "languages": {
        "de": "Deutsch",
        "en": "English",
        "fr": "Français",
        "es": "Español",
        "it": "Italiano",
        "pt": "Português",
        "pl": "Polski",
        "cs": "Čeština",
        "hu": "Magyar",
        "uk": "Українська",
        "ru": "Русский"
      },
      "events": {
        "title": "Events",
        "subtitle": "Discover our upcoming events and register directly",
        "upcoming": "Upcoming Events",
        "past": "Past Events",
        "noEvents": "No events found",
        "noEventsDescription": "There are currently no events planned. Check back soon!",
        "register": "Register now",
        "moreInfo": "More information",
        "addToCalendar": "Add to calendar",
        "exportCalendar": "Export calendar",
        "recently": "Recently",
        "viewAusschreibung": "View announcement"
      },
      "about": {
        "title": "About Us",
        "subtitle": "Discover the history and mission of ASC Fechten Wien",
        "history": {
          "title": "Our History",
          "paragraph1": "The Academic Sports Club Fechten Wien was founded in 1970 and looks back on a long and successful tradition in fencing. What began as a small student group has evolved into one of Austria's leading fencing clubs.",
          "paragraph2": "Over the years, we have trained hundreds of fencers, from beginners to international competitors. Our coaches bring decades of experience and have themselves competed at the highest level.",
          "paragraph3": "Today, we are proud to be a vibrant community that combines tradition and innovation. Our club stands for quality, fair play, and the promotion of fencing at all levels.",
          "since": "Since 1970",
          "experience": "Over 50 years of experience",
          "members": "200+ members",
          "community": "Strong community",
          "titles": "Numerous titles",
          "achievements": "National & international achievements"
        },
        "mission": {
          "title": "Our Mission",
          "description": "Our goal is to promote fencing in all its facets and provide a platform for athletic development and personal growth. We believe in the transformative power of fencing.",
          "valueIntro": "Our core values are:",
          "values": {
            "training": "Excellent training quality for all age groups",
            "fairplay": "Fair play and respect in competition and training",
            "methods": "Modern training methods and traditional values",
            "community": "A strong, supportive community"
          }
        },
        "team": {
          "title": "Our Team",
          "headTrainer": "Head Coach",
          "trainer": "Coach",
          "youthTrainer": "Youth Coach",
          "descriptions": {
            "alois": "Long-time head coach with international experience. Specialist in épée and foil with over 40 years of coaching experience.",
            "dorothea": "Experienced coach for all weapons. Particularly committed to youth development and recreational sports.",
            "dietmar": "Technical director and specialist in modern training methods. Focus on biomechanical optimization.",
            "viktor": "Competition coach specializing in tactical training. Former national team fencer.",
            "franziska": "Rising talent and aspiring coach. Specialized in youth training and modern teaching methods.",
            "lukas": "Youth coordinator and specialist in beginner training. Brings fresh approaches to traditional training methods.",
            "nicolas": "Young, motivated coach focused on playful learning and modern training approaches."
          }
        }
      },
      "tournaments": {
        "title": "Tournaments",
        "subtitle": "Exciting competitions and great achievements - experience fencing at the highest level",
        "upcoming": "Upcoming Tournaments",
        "past": "Past Tournaments",
        "weapon": "Weapon",
        "weapons": {
          "foil": "Foil",
          "epee": "Épée",
          "sabre": "Sabre"
        },
        "registration": "Registration",
        "results": "Results",
        "archive": "Tournament Archive",
        "showMore": "Show more",
        "showLess": "Show less",
        "noUpcoming": "No upcoming tournaments at this time",
        "noPast": "No past tournaments"
      },
      "calendar": {
        "addToGoogle": "Add to Google Calendar",
        "addToOutlook": "Add to Outlook",
        "downloadIcs": "Download ICS file",
        "addToCalendar": "Add to calendar"
      },
      "blog": {
        "title": "Blog & News",
        "description": "Discover the latest news, training tips, and success stories from the fascinating world of fencing.",
        "morePosts": "More posts"
      },
      "gallery": {
        "title": "Gallery",
        "description": "Insights into our club life - from training to major tournaments"
      },
      "training": {
        "title": "Training",
        "subtitle": "Professional fencing training for all age groups and skill levels",
        "loading": "Loading training data...",
        "youthTraining": "Youth Training",
        "clubTraining": "Club Training",
        "studentCourses": "Student Courses",
        "bookableVia": "University courses - Bookable via the",
        "usiSite": "USI website",
        "filterLegend": "Filter & Legend",
        "weapons": "Weapons",
        "targetGroups": "Target Groups",
        "beginners": "Beginners",
        "advanced": "Advanced",
        "tournament": "Competition Fencers",
        "days": {
          "monday": "Monday",
          "tuesday": "Tuesday",
          "wednesday": "Wednesday",
          "thursday": "Thursday",
          "friday": "Friday"
        },
        "registration": {
          "title": "Training Registration",
          "subtitle": "Sign up for a free trial training session",
          "name": "Name",
          "email": "Email",
          "phone": "Phone",
          "experience": "Fencing experience",
          "experiencePlaceholder": "Describe your previous fencing experience",
          "message": "Message",
          "messagePlaceholder": "Additional information or questions",
          "submit": "Submit registration",
          "submitting": "Submitting...",
          "success": "Registration submitted successfully!",
          "successDescription": "We will get back to you as soon as possible.",
          "error": "Error submitting",
          "errorDescription": "Please try again later or contact us directly."
        }
      },
      "home": {
        "hero": {
          "title": "Welcome to ASC Fechten Wien",
          "subtitle": "Experience the fascination of fencing",
          "description": "Discover the elegant art of fencing in our traditional club. From beginners to professionals – we offer the right training for everyone.",
          "joinButton": "Join now",
          "learnMoreButton": "Learn more",
          "watchVideoButton": "Watch video"
        },
        "fencingRules": {
          "title": "The Rules of Fencing",
          "subtitle": "Understand the basics of this elegant sport",
          "videoTitle": "Introduction to fencing rules",
          "basicRulesTitle": "Basic Rules of Fencing",
          "targetZones": {
            "title": "Target Zones",
            "description": "Depending on the weapon, valid target zones vary - from the torso in foil to the entire body in épée."
          },
          "rightOfWay": {
            "title": "Right of Way",
            "description": "In foil and sabre, the right of way determines who scores when both fencers hit simultaneously."
          },
          "scoring": {
            "title": "Scoring System",
            "description": "A bout is fought to 15 hits or until the time limit of 9 minutes is reached."
          },
          "safety": {
            "title": "Safety",
            "description": "Full protective equipment and strict safety rules ensure maximum protection."
          },
          "fairPlay": {
            "title": "Fair Play",
            "description": "Respect for the opponent and adherence to the rules are paramount in fencing."
          },
          "tip": "Tip: Start with foil – it's ideal for beginners!"
        },
        "weapons": {
          "title": "Our Weapon Disciplines",
          "subtitle": "Three disciplines, infinite possibilities",
          "foil": {
            "name": "Foil",
            "description": "The foil is the classic training weapon of fencing. Only the torso may be targeted.",
            "weight": "Weight: approx. 500g",
            "blade": "Blade: flexible, rectangular cross-section",
            "target": "Target area: Torso",
            "rightOfWay": "Right of way: Yes",
            "motto": "Ideal for beginners – elegance and precision are in the foreground"
          },
          "epee": {
            "name": "Épée",
            "description": "The épée is the heaviest weapon. The entire body is the target area, enabling tactical variety.",
            "weight": "Weight: approx. 770g",
            "blade": "Blade: stiff, triangular cross-section",
            "target": "Target area: Entire body",
            "rightOfWay": "Right of way: No",
            "motto": "For strategists – patience and timing decide victory and defeat"
          },
          "sabre": {
            "name": "Sabre",
            "description": "The sabre is the most dynamic weapon. Both cuts and thrusts are allowed, leading to spectacular bouts.",
            "weight": "Weight: approx. 500g",
            "blade": "Blade: flexible, rectangular cross-section",
            "target": "Target area: Upper body",
            "rightOfWay": "Right of way: Yes",
            "motto": "For tempo fencers – speed and aggressiveness are decisive"
          },
          "tryAllWeapons": "Interested? Try all three weapons in our trial training!",
          "toTrialTraining": "To trial training"
        },
        "about": {
          "title": "Why ASC Fechten Wien?",
          "description": "Over 50 years of experience, modern training methods, and a strong community make us your first choice for fencing.",
          "features": {
            "training": {
              "title": "Professional Training",
              "description": "From beginner to competition level – we offer the right training for everyone."
            },
            "community": {
              "title": "Strong Community",
              "description": "Become part of a vibrant fencing community and make new friends."
            },
            "tournaments": {
              "title": "Tournaments & Competitions",
              "description": "Regular participation in national and international tournaments for all skill levels."
            },
            "schedule": {
              "title": "Flexible Training Times",
              "description": "Train when it suits you – we offer courses for every schedule and level."
            }
          }
        },
        "cta": {
          "title": "Ready for your first training?",
          "description": "Whether beginner or advanced – we have the right training for you. Come by and discover the fascination of fencing!",
          "contactButton": "Get in touch",
          "closeVideo": "Close video"
        }
      },
      "header": {
        "search": "Search",
        "searchPlaceholder": "Search...",
        "openSearch": "Open search",
        "facebookLabel": "Visit ASC Fechten Wien on Facebook",
        "instagramLabel": "Visit ASC Fechten Wien on Instagram",
        "youtubeLabel": "Visit ASC Fechten Wien on YouTube"
      },
      "contact": {
        "title": "Contact",
        "subtitle": "Do you have questions or want to get to know us? We look forward to hearing from you!",
        "form": {
          "title": "Write to us",
          "name": "Name",
          "email": "Email",
          "subject": "Subject",
          "message": "Message",
          "messagePlaceholder": "Your message to us...",
          "send": "Send message",
          "sending": "Sending...",
          "required": "*",
          "successTitle": "Message sent successfully!",
          "successDescription": "We will get back to you as soon as possible.",
          "errorTitle": "Error sending",
          "errorDescription": "Please try again later or contact us directly."
        },
        "social": {
          "title": "Follow us"
        },
        "info": {
          "title": "Contact Information",
          "address": {
            "title": "Address",
            "content": "University Sports Centre Vienna\nAuf der Schmelz 6\n1150 Vienna, Austria"
          },
          "phone": {
            "title": "Phone",
            "number": "+43 69910866515",
            "note": "Available during training hours"
          },
          "email": {
            "title": "Email",
            "address": "info@asc-fechten.com",
            "note": "We respond within 24 hours"
          },
          "training": {
            "title": "Training Times",
            "monday": "Monday: 4:15 PM - 8:30 PM",
            "tuesday": "Tuesday: 8:00 PM - 9:30 PM",
            "wednesday": "Wednesday: 4:00 PM - 8:00 PM",
            "thursday": "Thursday: 5:30 PM - 8:30 PM",
            "friday": "Friday: 4:00 PM - 7:00 PM"
          }
        },
        "board": {
          "title": "The Board of ASC Fechten Wien",
          "chairman": "Chairman and Sports Director",
          "viceChairman": "Vice Chairman",
          "secretary": "Secretary",
          "treasurer": "Treasurer",
          "weaponMasterFoil": "Weapon Master Foil",
          "weaponMasterEpee": "Weapon Master Épée",
          "weaponMasterSaber": "Weapon Master Sabre",
          "youth": "Youth",
          "trustPerson": "Trusted Person",
          "auditor": "Auditor"
        },
        "partners": {
          "title": "Our Partners"
        }
      },
      "footer": {
        "contact": "Contact",
        "address": "University Sports Centre Vienna\nAuf der Schmelz 6, 1150 Vienna",
        "phone": "+43 69910866515",
        "email": "info@asc-fechten.com",
        "trainingTimes": "Training Times",
        "monday": "Monday: 4:15 PM - 8:30 PM",
        "tuesday": "Tuesday: 8:00 PM - 9:30 PM",
        "wednesday": "Wednesday: 4:00 PM - 8:00 PM",
        "thursday": "Thursday: 5:30 PM - 8:30 PM",
        "friday": "Friday: 4:00 PM - 7:00 PM",
        "followUs": "Follow us",
        "quickLinks": "Quick Links",
        "downloads": "Downloads",
        "news": "News",
        "tournaments": "Tournaments",
        "training": "Training",
        "gallery": "Gallery",
        "archive": "Archive",
        "bankDetails": "Bank Details",
        "copyright": "© 2024 Academic Sports Club Fechten Wien. All rights reserved.",
        "webdesign": "Web design by Wgtdigital",
        "impressum": "Legal Notice",
        "privacy": "Privacy Policy",
        "terms": "Terms & Conditions"
      },
      "admin": {
        "adminPanel": "Admin Panel",
        "navigation": "Navigation",
        "dashboard": "Dashboard",
        "users": "Users",
        "training": "Training",
        "blog": "Blog & News",
        "events": "Events",
        "media": "Media Library",
        "tournaments": "Tournaments",
        "files": "Files",
        "banner": "Banner",
        "analytics": "Analytics",
        "settings": "Settings",
        "backToWebsite": "Back to Website",
        "logout": "Logout",
        "userManagement": {
          "title": "User Management",
          "selectRole": "Select role",
          "noUsers": "No users found",
          "searchPlaceholder": "Search users...",
          "role": "Role",
          "email": "Email",
          "displayName": "Display Name",
          "createdAt": "Created at",
          "actions": "Actions",
          "totalUsers": "Total users",
          "administrators": "Administrators",
          "moderators": "Moderators",
          "allUsers": "All users",
          "roles": "Roles",
          "notSpecified": "Not specified",
          "noRoles": "No roles",
          "clickToRemove": "Click to remove",
          "confirmRemoveRole": "Remove role?",
          "confirmRemoveRoleMessage": "Do you really want to remove the role \"{{role}}\" from {{email}}?",
          "adminWarning": "Warning: this person will lose all administrator rights.",
          "removeRole": "Remove role",
          "editUser": "Edit user",
          "assignNewRole": "Assign new role",
          "assign": "Assign",
          "user": "User",
          "moderator": "Moderator",
          "administrator": "Administrator",
          "cancel": "Cancel",
          "save": "Save",
          "deleteUser": "Delete user",
          "confirmDeleteUser": "Delete user?",
          "confirmDeleteMessage": "This action cannot be undone. The account and all related data will be permanently deleted.",
          "errors": {
            "loadUsers": "Users could not be loaded",
            "roleExists": "This role is already assigned",
            "selfAdmin": "You cannot make yourself an administrator",
            "assignRole": "Role could not be assigned",
            "selfRemoveAdmin": "You cannot remove your own administrator role",
            "lastAdmin": "The last administrator cannot be removed",
            "removeRole": "Role could not be removed",
            "updateProfile": "Profile could not be saved",
            "selfDelete": "You cannot delete yourself",
            "deleteUser": "User could not be deleted"
          },
          "success": {
            "roleAssigned": "Role \"{{role}}\" assigned",
            "roleRemoved": "Role \"{{role}}\" removed",
            "profileUpdated": "Profile saved",
            "userDeleted": "User deleted"
          }
        },
        "placeholders": {
          "eventLocation": "e.g. Vienna, Austria",
          "pdfUrl": "https://clubwebsite.at/document.pdf",
          "imageUrl": "https://clubwebsite.at/image.jpg",
          "selectWeapon": "Select weapon",
          "selectGender": "Select gender",
          "selectSeason": "Select season",
          "selectEvent": "Select event",
          "selectDay": "Select day",
          "selectLevel": "Select level",
          "selectCategory": "Select category",
          "enterName": "Enter name...",
          "enterDescription": "Enter description...",
          "enterTitle": "Enter title...",
          "enterAuthor": "Enter author...",
          "enterTime": "e.g. 5:30 PM - 7:00 PM",
          "enterAddress": "e.g. 1150, Oeverseerstr. 2C",
          "googleMapsUrl": "Google Maps URL",
          "courseInfo": "Additional course information",
          "tags": "Tags separated by comma",
          "points": "Points (e.g. 206.5 P)",
          "position": "Position",
          "filename": "Enter filename...",
          "searchFiles": "Search files..."
        }
      }
    }
  },
  fr: {
    translation: {
      "common": { "loading": "Chargement...", "save": "Enregistrer", "cancel": "Annuler", "delete": "Supprimer", "edit": "Modifier", "create": "Créer", "close": "Fermer", "back": "Retour", "next": "Suivant", "search": "Rechercher", "filter": "Filtrer", "all": "Tous" },
      "navigation": { "home": "Accueil", "about": "À propos", "training": "Entraînement", "tournaments": "Tournois", "events": "Événements", "gallery": "Galerie", "blog": "Actualités", "contact": "Contact" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Tournois", "subtitle": "Des compétitions passionnantes et de grands succès - vivez l'escrime au plus haut niveau", "upcoming": "Tournois à venir", "past": "Tournois passés", "weapon": "Arme", "weapons": { "foil": "Fleuret", "epee": "Épée", "sabre": "Sabre" }, "registration": "Inscription", "results": "Résultats", "archive": "Archives des tournois", "showMore": "Afficher plus", "showLess": "Afficher moins", "noUpcoming": "Aucun tournoi à venir", "noPast": "Aucun tournoi passé" },
      "events": { "title": "Événements", "subtitle": "Découvrez nos prochains événements et inscrivez-vous directement", "upcoming": "Événements à venir", "past": "Événements passés", "location": "Lieu", "date": "Date", "register": "S'inscrire", "details": "Détails", "noUpcoming": "Aucun événement à venir", "prospectus": "Annonce" },
      "gallery": { "title": "Galerie", "description": "Aperçu de notre vie associative - de l'entraînement aux grands tournois" },
      "blog": { "title": "Blog & Actualités", "description": "Découvrez les dernières nouvelles, conseils d'entraînement et histoires de succès du monde fascinant de l'escrime.", "morePosts": "Plus d'articles" },
      "training": { "title": "Entraînement", "subtitle": "Des offres d'entraînement professionnelles pour tous les niveaux" },
      "contact": { "title": "Contact", "subtitle": "Nous avons hâte de vous entendre" },
      "header": { "search": "Rechercher", "searchPlaceholder": "Rechercher...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Contact", "address": "Oeverseestraße 2C\n1150 Vienne", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Horaires d'entraînement", "monday": "Lundi: 17h00 - 19h00", "tuesday": "Mardi: 17h00 - 19h00", "wednesday": "Mercredi: 17h00 - 19h00", "thursday": "Jeudi: 17h00 - 19h00", "friday": "Vendredi: 17h00 - 19h00", "quickLinks": "Liens rapides", "downloads": "Téléchargements", "news": "Actualités", "tournaments": "Tournois", "training": "Entraînement", "gallery": "Galerie", "archive": "Archives", "followUs": "Suivez-nous", "bankDetails": "Coordonnées bancaires", "copyright": "© 2024 ASC Fechten Wien. Tous droits réservés.", "webdesign": "Webdesign par WGT Digital", "impressum": "Mentions légales", "privacy": "Protection des données", "terms": "CGV" }
    }
  },
  es: {
    translation: {
      "common": { "loading": "Cargando...", "save": "Guardar", "cancel": "Cancelar", "delete": "Eliminar", "edit": "Editar", "create": "Crear", "close": "Cerrar", "back": "Atrás", "next": "Siguiente", "search": "Buscar", "filter": "Filtrar", "all": "Todos" },
      "navigation": { "home": "Inicio", "about": "Sobre nosotros", "training": "Entrenamiento", "tournaments": "Torneos", "events": "Eventos", "gallery": "Galería", "blog": "Noticias", "contact": "Contacto" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Torneos", "subtitle": "Competiciones emocionantes y grandes éxitos - vive la esgrima al más alto nivel", "upcoming": "Próximos torneos", "past": "Torneos pasados", "weapon": "Arma", "weapons": { "foil": "Florete", "epee": "Espada", "sabre": "Sable" }, "registration": "Inscripción", "results": "Resultados", "archive": "Archivo de torneos", "showMore": "Mostrar más", "showLess": "Mostrar menos", "noUpcoming": "No hay torneos próximos", "noPast": "No hay torneos pasados" },
      "events": { "title": "Eventos", "subtitle": "Descubre nuestros próximos eventos e inscríbete directamente", "upcoming": "Próximos eventos", "past": "Eventos pasados", "location": "Lugar", "date": "Fecha", "register": "Inscribirse", "details": "Detalles", "noUpcoming": "No hay eventos próximos", "prospectus": "Convocatoria" },
      "gallery": { "title": "Galería", "description": "Perspectivas de nuestra vida asociativa - desde el entrenamiento hasta los grandes torneos" },
      "blog": { "title": "Blog y Noticias", "description": "Descubre las últimas noticias, consejos de entrenamiento e historias de éxito del fascinante mundo de la esgrima.", "morePosts": "Más artículos" },
      "training": { "title": "Entrenamiento", "subtitle": "Ofertas de entrenamiento profesional para todos los niveles" },
      "contact": { "title": "Contacto", "subtitle": "Esperamos tus noticias" },
      "header": { "search": "Buscar", "searchPlaceholder": "Buscar...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Contacto", "address": "Oeverseestraße 2C\n1150 Viena", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Horarios de entrenamiento", "monday": "Lunes: 17:00 - 19:00", "tuesday": "Martes: 17:00 - 19:00", "wednesday": "Miércoles: 17:00 - 19:00", "thursday": "Jueves: 17:00 - 19:00", "friday": "Viernes: 17:00 - 19:00", "quickLinks": "Enlaces rápidos", "downloads": "Descargas", "news": "Noticias", "tournaments": "Torneos", "training": "Entrenamiento", "gallery": "Galería", "archive": "Archivo", "followUs": "Síguenos", "bankDetails": "Datos bancarios", "copyright": "© 2024 ASC Fechten Wien. Todos los derechos reservados.", "webdesign": "Diseño web por WGT Digital", "impressum": "Aviso legal", "privacy": "Protección de datos", "terms": "CGV" }
    }
  },
  it: {
    translation: {
      "common": { "loading": "Caricamento...", "save": "Salva", "cancel": "Annulla", "delete": "Elimina", "edit": "Modifica", "create": "Crea", "close": "Chiudi", "back": "Indietro", "next": "Avanti", "search": "Cerca", "filter": "Filtra", "all": "Tutti" },
      "navigation": { "home": "Home", "about": "Chi siamo", "training": "Allenamento", "tournaments": "Tornei", "events": "Eventi", "gallery": "Galleria", "blog": "Notizie", "contact": "Contatto" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Tornei", "subtitle": "Competizioni emozionanti e grandi successi - vivi la scherma al massimo livello", "upcoming": "Prossimi tornei", "past": "Tornei passati", "weapon": "Arma", "weapons": { "foil": "Fioretto", "epee": "Spada", "sabre": "Sciabola" }, "registration": "Iscrizione", "results": "Risultati", "archive": "Archivio tornei", "showMore": "Mostra di più", "showLess": "Mostra di meno", "noUpcoming": "Nessun torneo in programma", "noPast": "Nessun torneo passato" },
      "events": { "title": "Eventi", "subtitle": "Scopri i nostri prossimi eventi e iscriviti direttamente", "upcoming": "Prossimi eventi", "past": "Eventi passati", "location": "Luogo", "date": "Data", "register": "Iscriviti", "details": "Dettagli", "noUpcoming": "Nessun evento in programma", "prospectus": "Bando" },
      "gallery": { "title": "Galleria", "description": "Uno sguardo alla nostra vita associativa - dall'allenamento ai grandi tornei" },
      "blog": { "title": "Blog e Notizie", "description": "Scopri le ultime notizie, consigli di allenamento e storie di successo dall'affascinante mondo della scherma.", "morePosts": "Altri articoli" },
      "training": { "title": "Allenamento", "subtitle": "Offerte di allenamento professionale per tutti i livelli" },
      "contact": { "title": "Contatto", "subtitle": "Non vediamo l'ora di sentirti" },
      "header": { "search": "Cerca", "searchPlaceholder": "Cerca...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Contatto", "address": "Oeverseestraße 2C\n1150 Vienna", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Orari di allenamento", "monday": "Lunedì: 17:00 - 19:00", "tuesday": "Martedì: 17:00 - 19:00", "wednesday": "Mercoledì: 17:00 - 19:00", "thursday": "Giovedì: 17:00 - 19:00", "friday": "Venerdì: 17:00 - 19:00", "quickLinks": "Link rapidi", "downloads": "Download", "news": "Notizie", "tournaments": "Tornei", "training": "Allenamento", "gallery": "Galleria", "archive": "Archivio", "followUs": "Seguici", "bankDetails": "Coordinate bancarie", "copyright": "© 2024 ASC Fechten Wien. Tutti i diritti riservati.", "webdesign": "Web design di WGT Digital", "impressum": "Impressum", "privacy": "Protezione dei dati", "terms": "CGV" }
    }
  },
  pt: {
    translation: {
      "common": { "loading": "Carregando...", "save": "Salvar", "cancel": "Cancelar", "delete": "Excluir", "edit": "Editar", "create": "Criar", "close": "Fechar", "back": "Voltar", "next": "Próximo", "search": "Pesquisar", "filter": "Filtrar", "all": "Todos" },
      "navigation": { "home": "Início", "about": "Sobre nós", "training": "Treino", "tournaments": "Torneios", "events": "Eventos", "gallery": "Galeria", "blog": "Notícias", "contact": "Contacto" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Torneios", "subtitle": "Competições emocionantes e grandes conquistas - viva a esgrima ao mais alto nível", "upcoming": "Próximos torneios", "past": "Torneios passados", "weapon": "Arma", "weapons": { "foil": "Florete", "epee": "Espada", "sabre": "Sabre" }, "registration": "Inscrição", "results": "Resultados", "archive": "Arquivo de torneios", "showMore": "Mostrar mais", "showLess": "Mostrar menos", "noUpcoming": "Nenhum torneio próximo", "noPast": "Nenhum torneio passado" },
      "events": { "title": "Eventos", "subtitle": "Descubra os nossos próximos eventos e inscreva-se diretamente", "upcoming": "Próximos eventos", "past": "Eventos passados", "location": "Local", "date": "Data", "register": "Inscrever-se", "details": "Detalhes", "noUpcoming": "Nenhum evento próximo", "prospectus": "Anúncio" },
      "gallery": { "title": "Galeria", "description": "Olhares sobre a nossa vida associativa - do treino aos grandes torneios" },
      "blog": { "title": "Blog e Notícias", "description": "Descubra as últimas notícias, dicas de treino e histórias de sucesso do fascinante mundo da esgrima.", "morePosts": "Mais artigos" },
      "training": { "title": "Treino", "subtitle": "Ofertas de treino profissional para todos os níveis" },
      "contact": { "title": "Contacto", "subtitle": "Estamos ansiosos por ouvi-lo" },
      "header": { "search": "Pesquisar", "searchPlaceholder": "Pesquisar...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Contacto", "address": "Oeverseestraße 2C\n1150 Viena", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Horários de treino", "monday": "Segunda: 17:00 - 19:00", "tuesday": "Terça: 17:00 - 19:00", "wednesday": "Quarta: 17:00 - 19:00", "thursday": "Quinta: 17:00 - 19:00", "friday": "Sexta: 17:00 - 19:00", "quickLinks": "Links rápidos", "downloads": "Downloads", "news": "Notícias", "tournaments": "Torneios", "training": "Treino", "gallery": "Galeria", "archive": "Arquivo", "followUs": "Siga-nos", "bankDetails": "Dados bancários", "copyright": "© 2024 ASC Fechten Wien. Todos os direitos reservados.", "webdesign": "Web design por WGT Digital", "impressum": "Impressum", "privacy": "Proteção de dados", "terms": "CGV" }
    }
  },
  pl: {
    translation: {
      "common": { "loading": "Ładowanie...", "save": "Zapisz", "cancel": "Anuluj", "delete": "Usuń", "edit": "Edytuj", "create": "Utwórz", "close": "Zamknij", "back": "Wstecz", "next": "Dalej", "search": "Szukaj", "filter": "Filtruj", "all": "Wszystkie" },
      "navigation": { "home": "Strona główna", "about": "O nas", "training": "Trening", "tournaments": "Turnieje", "events": "Wydarzenia", "gallery": "Galeria", "blog": "Aktualności", "contact": "Kontakt" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Turnieje", "subtitle": "Emocjonujące zawody i wielkie sukcesy - przeżyj szermierke na najwyższym poziomie", "upcoming": "Nadchodzące turnieje", "past": "Minione turnieje", "weapon": "Broń", "weapons": { "foil": "Floret", "epee": "Szpada", "sabre": "Szabla" }, "registration": "Rejestracja", "results": "Wyniki", "archive": "Archiwum turniejów", "showMore": "Pokaż więcej", "showLess": "Pokaż mniej", "noUpcoming": "Brak nadchodzących turniejów", "noPast": "Brak minionych turniejów" },
      "events": { "title": "Wydarzenia", "subtitle": "Odkryj nasze nadchodzące wydarzenia i zapisz się bezpośrednio", "upcoming": "Nadchodzące wydarzenia", "past": "Minione wydarzenia", "location": "Miejsce", "date": "Data", "register": "Zapisz się", "details": "Szczegóły", "noUpcoming": "Brak nadchodzących wydarzeń", "prospectus": "Ogłoszenie" },
      "gallery": { "title": "Galeria", "description": "Wgląd w nasze życie klubowe - od treningów po wielkie turnieje" },
      "blog": { "title": "Blog i Aktualności", "description": "Odkryj najnowsze wiadomości, porady treningowe i historie sukcesu z fascynującego świata szermierki.", "morePosts": "Więcej artykułów" },
      "training": { "title": "Trening", "subtitle": "Profesjonalna oferta treningowa dla wszystkich poziomów" },
      "contact": { "title": "Kontakt", "subtitle": "Czekamy na wiadomość od Ciebie" },
      "header": { "search": "Szukaj", "searchPlaceholder": "Szukaj...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Kontakt", "address": "Oeverseestraße 2C\n1150 Wiedeń", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Godziny treningów", "monday": "Poniedziałek: 17:00 - 19:00", "tuesday": "Wtorek: 17:00 - 19:00", "wednesday": "Środa: 17:00 - 19:00", "thursday": "Czwartek: 17:00 - 19:00", "friday": "Piątek: 17:00 - 19:00", "quickLinks": "Szybkie linki", "downloads": "Pobieranie", "news": "Aktualności", "tournaments": "Turnieje", "training": "Trening", "gallery": "Galeria", "archive": "Archiwum", "followUs": "Śledź nas", "bankDetails": "Dane bankowe", "copyright": "© 2024 ASC Fechten Wien. Wszelkie prawa zastrzeżone.", "webdesign": "Webdesign WGT Digital", "impressum": "Impressum", "privacy": "Ochrona danych", "terms": "OWU" }
    }
  },
  cs: {
    translation: {
      "common": { "loading": "Načítání...", "save": "Uložit", "cancel": "Zrušit", "delete": "Smazat", "edit": "Upravit", "create": "Vytvořit", "close": "Zavřít", "back": "Zpět", "next": "Další", "search": "Hledat", "filter": "Filtrovat", "all": "Vše" },
      "navigation": { "home": "Úvodní stránka", "about": "O nás", "training": "Trénink", "tournaments": "Turnaje", "events": "Akce", "gallery": "Galerie", "blog": "Novinky", "contact": "Kontakt" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Turnaje", "subtitle": "Vzrušující soutěže a velké úspěchy - zažijte šerm na nejvyšší úrovni", "upcoming": "Nadcházející turnaje", "past": "Minulé turnaje", "weapon": "Zbraň", "weapons": { "foil": "Fleret", "epee": "Kord", "sabre": "Šavle" }, "registration": "Registrace", "results": "Výsledky", "archive": "Archiv turnajů", "showMore": "Zobrazit více", "showLess": "Zobrazit méně", "noUpcoming": "Žádné nadcházející turnaje", "noPast": "Žádné minulé turnaje" },
      "events": { "title": "Akce", "subtitle": "Objevte naše nadcházející akce a přihlaste se přímo", "upcoming": "Nadcházející akce", "past": "Minulé akce", "location": "Místo", "date": "Datum", "register": "Přihlásit se", "details": "Podrobnosti", "noUpcoming": "Žádné nadcházející akce", "prospectus": "Propozice" },
      "gallery": { "title": "Galerie", "description": "Nahlédněte do našeho klubového života - od tréninků po velké turnaje" },
      "blog": { "title": "Blog a Novinky", "description": "Objevte nejnovější zprávy, tréninkové tipy a příběhy úspěchů z fascinujícího světa šermu.", "morePosts": "Další články" },
      "training": { "title": "Trénink", "subtitle": "Profesionální tréninková nabídka pro všechny úrovně" },
      "contact": { "title": "Kontakt", "subtitle": "Těšíme se na vaši zprávu" },
      "header": { "search": "Hledat", "searchPlaceholder": "Hledat...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Kontakt", "address": "Oeverseestraße 2C\n1150 Vídeň", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Tréninkové časy", "monday": "Pondělí: 17:00 - 19:00", "tuesday": "Úterý: 17:00 - 19:00", "wednesday": "Středa: 17:00 - 19:00", "thursday": "Čtvrtek: 17:00 - 19:00", "friday": "Pátek: 17:00 - 19:00", "quickLinks": "Rychlé odkazy", "downloads": "Ke stažení", "news": "Novinky", "tournaments": "Turnaje", "training": "Trénink", "gallery": "Galerie", "archive": "Archiv", "followUs": "Sledujte nás", "bankDetails": "Bankovní údaje", "copyright": "© 2024 ASC Fechten Wien. Všechna práva vyhrazena.", "webdesign": "Webdesign WGT Digital", "impressum": "Impressum", "privacy": "Ochrana údajů", "terms": "VOP" }
    }
  },
  hu: {
    translation: {
      "common": { "loading": "Betöltés...", "save": "Mentés", "cancel": "Mégse", "delete": "Törlés", "edit": "Szerkesztés", "create": "Létrehozás", "close": "Bezárás", "back": "Vissza", "next": "Következő", "search": "Keresés", "filter": "Szűrés", "all": "Összes" },
      "navigation": { "home": "Kezdőlap", "about": "Rólunk", "training": "Edzés", "tournaments": "Versenyek", "events": "Események", "gallery": "Galéria", "blog": "Hírek", "contact": "Kapcsolat" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Versenyek", "subtitle": "Izgalmas versenyek és nagy sikerek - éld át a vívást a legmagasabb szinten", "upcoming": "Közelgő versenyek", "past": "Múltbeli versenyek", "weapon": "Fegyver", "weapons": { "foil": "Tőr", "epee": "Párbajtőr", "sabre": "Kard" }, "registration": "Regisztráció", "results": "Eredmények", "archive": "Versenyarchívum", "showMore": "Több megjelenítése", "showLess": "Kevesebb megjelenítése", "noUpcoming": "Nincs közelgő verseny", "noPast": "Nincs múltbeli verseny" },
      "events": { "title": "Események", "subtitle": "Fedezd fel közelgő eseményeinket és regisztrálj közvetlenül", "upcoming": "Közelgő események", "past": "Múltbeli események", "location": "Helyszín", "date": "Dátum", "register": "Regisztráció", "details": "Részletek", "noUpcoming": "Nincs közelgő esemény", "prospectus": "Kiírás" },
      "gallery": { "title": "Galéria", "description": "Betekintés egyesületi életünkbe - az edzésektől a nagy versenyekig" },
      "blog": { "title": "Blog és Hírek", "description": "Fedezd fel a legújabb híreket, edzéstippeket és sikertörténeteket a vívás lenyűgöző világából.", "morePosts": "További cikkek" },
      "training": { "title": "Edzés", "subtitle": "Professzionális edzésajánlatok minden szinthez" },
      "contact": { "title": "Kapcsolat", "subtitle": "Várjuk üzenetedet" },
      "header": { "search": "Keresés", "searchPlaceholder": "Keresés...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Kapcsolat", "address": "Oeverseestraße 2C\n1150 Bécs", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Edzésidők", "monday": "Hétfő: 17:00 - 19:00", "tuesday": "Kedd: 17:00 - 19:00", "wednesday": "Szerda: 17:00 - 19:00", "thursday": "Csütörtök: 17:00 - 19:00", "friday": "Péntek: 17:00 - 19:00", "quickLinks": "Gyors linkek", "downloads": "Letöltések", "news": "Hírek", "tournaments": "Versenyek", "training": "Edzés", "gallery": "Galéria", "archive": "Archívum", "followUs": "Kövess minket", "bankDetails": "Bankadatok", "copyright": "© 2024 ASC Fechten Wien. Minden jog fenntartva.", "webdesign": "Webdesign: WGT Digital", "impressum": "Impresszum", "privacy": "Adatvédelem", "terms": "ÁSZF" }
    }
  },
  uk: {
    translation: {
      "common": { "loading": "Завантаження...", "save": "Зберегти", "cancel": "Скасувати", "delete": "Видалити", "edit": "Редагувати", "create": "Створити", "close": "Закрити", "back": "Назад", "next": "Далі", "search": "Пошук", "filter": "Фільтр", "all": "Усі" },
      "navigation": { "home": "Головна", "about": "Про нас", "training": "Тренування", "tournaments": "Турніри", "events": "Заходи", "gallery": "Галерея", "blog": "Новини", "contact": "Контакт" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Турніри", "subtitle": "Захопливі змагання та великі успіхи - відчуйте фехтування на найвищому рівні", "upcoming": "Майбутні турніри", "past": "Минулі турніри", "weapon": "Зброя", "weapons": { "foil": "Рапіра", "epee": "Шпага", "sabre": "Шабля" }, "registration": "Реєстрація", "results": "Результати", "archive": "Архів турнірів", "showMore": "Показати більше", "showLess": "Показати менше", "noUpcoming": "Немає майбутніх турнірів", "noPast": "Немає минулих турнірів" },
      "events": { "title": "Заходи", "subtitle": "Відкрийте наші майбутні заходи та зареєструйтесь безпосередньо", "upcoming": "Майбутні заходи", "past": "Минулі заходи", "location": "Місце", "date": "Дата", "register": "Зареєструватися", "details": "Деталі", "noUpcoming": "Немає майбутніх заходів", "prospectus": "Оголошення" },
      "gallery": { "title": "Галерея", "description": "Погляд на наше клубне життя - від тренувань до великих турнірів" },
      "blog": { "title": "Блог та Новини", "description": "Відкрийте останні новини, поради з тренувань та історії успіху з захопливого світу фехтування.", "morePosts": "Більше статей" },
      "training": { "title": "Тренування", "subtitle": "Професійні пропозиції тренувань для всіх рівнів" },
      "contact": { "title": "Контакт", "subtitle": "Ми чекаємо на ваше повідомлення" },
      "header": { "search": "Пошук", "searchPlaceholder": "Пошук...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Контакт", "address": "Oeverseestraße 2C\n1150 Відень", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Час тренувань", "monday": "Понеділок: 17:00 - 19:00", "tuesday": "Вівторок: 17:00 - 19:00", "wednesday": "Середа: 17:00 - 19:00", "thursday": "Четвер: 17:00 - 19:00", "friday": "П'ятниця: 17:00 - 19:00", "quickLinks": "Швидкі посилання", "downloads": "Завантаження", "news": "Новини", "tournaments": "Турніри", "training": "Тренування", "gallery": "Галерея", "archive": "Архів", "followUs": "Слідкуйте за нами", "bankDetails": "Банківські реквізити", "copyright": "© 2024 ASC Fechten Wien. Усі права захищені.", "webdesign": "Веб-дизайн WGT Digital", "impressum": "Імпресум", "privacy": "Захист даних", "terms": "Умови" }
    }
  },
  ru: {
    translation: {
      "common": { "loading": "Загрузка...", "save": "Сохранить", "cancel": "Отмена", "delete": "Удалить", "edit": "Редактировать", "create": "Создать", "close": "Закрыть", "back": "Назад", "next": "Далее", "search": "Поиск", "filter": "Фильтр", "all": "Все" },
      "navigation": { "home": "Главная", "about": "О нас", "training": "Тренировки", "tournaments": "Турниры", "events": "Мероприятия", "gallery": "Галерея", "blog": "Новости", "contact": "Контакт" },
      "languages": { "de": "Deutsch", "en": "English", "fr": "Français", "es": "Español", "it": "Italiano", "pt": "Português", "pl": "Polski", "cs": "Čeština", "hu": "Magyar", "uk": "Українська", "ru": "Русский" },
      "tournaments": { "title": "Турниры", "subtitle": "Захватывающие соревнования и большие успехи - почувствуйте фехтование на высшем уровне", "upcoming": "Предстоящие турниры", "past": "Прошедшие турниры", "weapon": "Оружие", "weapons": { "foil": "Рапира", "epee": "Шпага", "sabre": "Сабля" }, "registration": "Регистрация", "results": "Результаты", "archive": "Архив турниров", "showMore": "Показать больше", "showLess": "Показать меньше", "noUpcoming": "Нет предстоящих турниров", "noPast": "Нет прошедших турниров" },
      "events": { "title": "Мероприятия", "subtitle": "Откройте наши предстоящие мероприятия и зарегистрируйтесь напрямую", "upcoming": "Предстоящие мероприятия", "past": "Прошедшие мероприятия", "location": "Место", "date": "Дата", "register": "Зарегистрироваться", "details": "Подробности", "noUpcoming": "Нет предстоящих мероприятий", "prospectus": "Объявление" },
      "gallery": { "title": "Галерея", "description": "Взгляд на нашу клубную жизнь - от тренировок до крупных турниров" },
      "blog": { "title": "Блог и Новости", "description": "Откройте последние новости, советы по тренировкам и истории успеха из увлекательного мира фехтования.", "morePosts": "Больше статей" },
      "training": { "title": "Тренировки", "subtitle": "Профессиональные предложения тренировок для всех уровней" },
      "contact": { "title": "Контакт", "subtitle": "Мы ждём вашего сообщения" },
      "header": { "search": "Поиск", "searchPlaceholder": "Поиск...", "facebookLabel": "Facebook", "instagramLabel": "Instagram", "youtubeLabel": "YouTube" },
      "footer": { "contact": "Контакт", "address": "Oeverseestraße 2C\n1150 Вена", "phone": "+43 1 234 5678", "email": "office@asc-fechten.com", "trainingTimes": "Время тренировок", "monday": "Понедельник: 17:00 - 19:00", "tuesday": "Вторник: 17:00 - 19:00", "wednesday": "Среда: 17:00 - 19:00", "thursday": "Четверг: 17:00 - 19:00", "friday": "Пятница: 17:00 - 19:00", "quickLinks": "Быстрые ссылки", "downloads": "Загрузки", "news": "Новости", "tournaments": "Турниры", "training": "Тренировки", "gallery": "Галерея", "archive": "Архив", "followUs": "Подписывайтесь", "bankDetails": "Банковские реквизиты", "copyright": "© 2024 ASC Fechten Wien. Все права защищены.", "webdesign": "Веб-дизайн WGT Digital", "impressum": "Импрессум", "privacy": "Защита данных", "terms": "Условия" }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Set German as default language
    fallbackLng: 'de',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
